export default {
  error: false,
  data: {
    secret_key: "",
    api_key: "",
    name: "",
  },
};
